import st from '../../styles/template.module.scss';
import RadioButton from '../RadioButton/RadioButton';

type ContentsType = {
    id?: string;
    label?: string;
    star?: boolean;
    colorBlock?: boolean;
    dataValue?: any;
    classNames?: any;
    array?: any;
    name?: string;
    showMore?: (value: any) => void;
    changeHandler?: (value: any) => void;
}

const RenderContent = ({ classNames = st.vertical, id = '', label = '', star, colorBlock, dataValue, array, name = '', showMore, changeHandler }: ContentsType) => {
    return (
        <div className={classNames} id={id}>
            <label>{label}{star ? <span>&nbsp;*</span> : false}</label>
            <div className={(colorBlock ? st.colorItems + ' ' : '') + st.typeItems}>
                {array?.map((item: any) => {
                    return (
                        <div className={st.typeItem}>
                            <label htmlFor={item.name}>
                                {colorBlock ? <span className={st.roundColor} style={{ backgroundColor: item.rgb_code }}></span> : false}
                                {item.name}
                            </label>
                            <RadioButton onChange={changeHandler}
                                id={item.name}
                                value={item.id ? item.id : '-'}
                                isChecked={dataValue + '' === item.id + ''}
                                name={name}
                            />
                            <span></span>
                        </div>
                    )
                })}
            </div>
            {showMore ? <button className={st.more_btn} onClick={showMore}>&nbsp;</button> : false}

        </div>
    )
}

export default RenderContent;